import React, { useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import EditIcon from "@mui/icons-material/Edit";
import ListIcon from "@mui/icons-material/List";
import ChatIcon from "@mui/icons-material/Chat";
import Styles from "../../Styles/CommomDashboard/ListCard.module.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ConsumerCapacityModal } from "../../pages/DashBoard/consumerCapacityModal";
import { getSelectedCapacityData } from "../../store/DashBoard/actions";
import chatService from "../Services/chat.service";
import { Button, Menu, MenuItem } from "@mui/material";
import Chat from "../chat/Chat";
import { PreviewModel } from "../../pages/DashBoard/previewModel";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import CustomConfirmBox from "../../pages/DashBoard/customConfirmBox";
import capacityConsumerService from "../Services/capacityConsumer.service";
import { toastProperties } from "../../commons/Toast/Toaster";
import { toast } from "react-toastify";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import documentUploadService from "../Services/documentUpload.service";
import UploadedDocument from "../../pages/Documents/UploadedDocument";

const MyListCard = ({
  item,
  getMatchingProfilesCon,
  getMatchingProfiles,
  selectedCardIndex,
  setSelectedCardIndex,
  setSelectedCardData,
  handleResetForm,
}) => {
  const moment = require("moment");
  const dispatch = useDispatch();
  const navigation = useNavigate();

  const ITEM_HEIGHT = 48;
  const [isModel, setIsModel] = useState(false);
  const [fromUserCapName, setFromUserCapName] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [acceptedCapData, setAcceptedCapData] = useState(null);
  const [isOpenChat, setOpenChat] = useState(false);
  const [UserCapName, setUserCapName] = useState(null);

  const [raModal, setRaModal] = useState(false);
  const [raId, setRaId] = useState(item?.id);
  const [duplicate, setDuplicate] = useState(false);

  const [viewDoc, setViewDoc] = useState(item?.tncDocument);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedFileData, setSelectedFileData] = useState(null);
  const [isPdfOpen, setIsPdfOpen] = useState(false);

  const open = Boolean(anchorEl);

  const role = useSelector((state) => state?.sessionState?.role);
  const unreadNotificationsObj = useSelector(
    (state) => state?.notificationReducer?.unreadNotifications
  );

  const handleEditClick = (item) => {
    setDuplicate(false);
    setIsModel(item);
  };

  const handleDuplicateClick = (item) => {
    setDuplicate(true);
    setIsModel(item);
  };

  const handleBidsReceived = (item) => {
    getSelectedCapacityData(item)(dispatch);
    navigation("/bids_received");
  };

  const handleChatClick = (event, item) => {
    setFromUserCapName(item?.name);
    setAnchorEl(event.currentTarget);
    setAcceptedCapData(null);
    chatService
      .getAllChatAcceptedCapacities(item?.id, role)
      .then((response) => {
        if (response?.data?.code === 200) {
          setAcceptedCapData(response?.data?.data);
        }
      });
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleCapNameClick = (e, capName) => {
    e.stopPropagation();
    setAnchorEl(null);
    setUserCapName({
      fromUser: fromUserCapName,
      toUser: capName,
    });
    setOpenChat(true);
  };

  const handleSelectCard = (data) => {
    handleResetForm();
    setSelectedCardIndex(data?.id);
    getMatchingProfilesCon(data.id);
    setSelectedCardData(data);
  };

  const initiateRA = () => {
    setRaModal(true);
  };

  const handleCloseNo = () => {
    setRaModal(false);
  };
  const handleHoldClose = async () => {
    let res = await capacityConsumerService.initRaDirectConsumer(raId);
    if (res?.data?.code === 200) {
      toast.success(res?.data?.message, toastProperties);
      handleCloseNo();
      window.location.reload();
    } else {
      toast.error(res?.data?.error, toastProperties);
    }
  };

  const handleViewFile = (id) => {
    getDocDataById(id, true);
  };

  const getDocDataById = (id, viewFile) => {
    documentUploadService
      .getDocumentById(id)
      .then((response) => {
        if (response?.data?.code === 200) {
          if (viewFile) {
            let fileTypeSplit = response?.data?.data?.fileName.split(".");
            setSelectedFiles(fileTypeSplit[fileTypeSplit?.length - 1]);
            setSelectedFileData(response?.data?.data?.fileInBytes);
            setIsPdfOpen(true);
          }
        }
      })
      .catch((err) => console.log("Api call Error:", err));
  };

  const handleClosePDFModal = () => {
    setIsPdfOpen(false);
  };

  return (
    <>
      {isPdfOpen && (
        <UploadedDocument
          fileData={selectedFileData}
          handleCloseModal={handleClosePDFModal}
          fileType={selectedFiles}
          isOpen={isPdfOpen}
          download={true}
        />
      )}
      {raModal && (
        <CustomConfirmBox
          title={"Confirmation"}
          message={`Do you want to proceed with Reverse Auction`}
          open={raModal}
          handleClose={handleHoldClose}
          handleCloseNo={handleCloseNo}
        />
      )}
      <div
        onClick={() => handleSelectCard(item)}
        className={
          selectedCardIndex === item?.id
            ? Styles.listMainContainerActive
            : Styles.listMainContainer
        }
      >
        <div className={Styles.detailsContainer}>
          <div className={Styles.itemNameText}>{item.name}</div>
          <div className={Styles.listingTime}>
            <div className={Styles.dateAndTimeText}>
              <div>{moment(item.dateStartAt).format("DD-MMM-yyyy")}</div>
              <div>{item.slotStartAt}</div>
            </div>
            <div>to</div>
            <div className={Styles.dateAndTimeText}>
              <div>{moment(item.dateEndAt).format("DD-MMM-yyyy")}</div>
              <div>
                {item.slotEndAt &&
                  (item.slotEndAt === "23:59" ? "24:00" : item.slotEndAt)}
              </div>
            </div>
          </div>
          <div className={Styles.quantityRateContainer}>
            <div className={Styles.qtyPricText}>
              <div>Quantity:-</div>
              <div>{item.purchaseEnergy || item?.sellEnergy} MW</div>
            </div>
            <div className={Styles.qtyPricText}>
              <div>Energy Rate:-</div>
              <div>
                ₹{" "}
                {item?.energyRateStr ||
                  item.landingCost?.toFixed(2) ||
                  item?.sellingCost?.toFixed(2)}
              </div>
            </div>
          </div>
          <div className={Styles.expiesText}>
            Expires on {moment(item.bidEndAt).format("DD-MMM-yyyy")}{" "}
            {moment(item.bidEndAt).format("hh:mm A")}
          </div>
          {item?.isPushed && (
            <div className={Styles.expiesText}>Pushed to Trade Connect</div>
          )}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className={Styles.tagContainer}
        >
          {unreadNotificationsObj[item.name] ? (
            <OverlayTrigger
              placement="right"
              overlay={
                <Tooltip>
                  {unreadNotificationsObj[item.name] ||
                    "Something went wrong will notify you"}
                </Tooltip>
              }
            >
              <NotificationsActiveIcon style={{ fontSize: "20px" }} />
            </OverlayTrigger>
          ) : (
            <NotificationsNoneIcon style={{ fontSize: "25px" }} />
          )}
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Edit Listing</Tooltip>}
          >
            <div
              className={Styles.iconContainer}
              style={{ background: "#6610f2" }}
              onClick={(e) => {
                e.stopPropagation();
                handleEditClick(item);
              }}
            >
              <EditIcon style={{ fontSize: "20px", color: "#fff" }} />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>View Received</Tooltip>}
          >
            <div
              className={Styles.iconContainer}
              style={{ background: "#198754" }}
              onClick={(e) => {
                e.stopPropagation();
                handleBidsReceived(item);
              }}
            >
              <ListIcon style={{ fontSize: "20px", color: "#fff" }} />
            </div>
          </OverlayTrigger>
          {/* {role === "CONSUMER" && !item?.isPushed && (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Inititate Reverse Auction</Tooltip>}
            >
              <div
                className={Styles.iconContainer}
                style={{
                  background: "#198754",
                  color: "#fff",
                  fontSize: "12px",
                  fontWeight: "500",
                }}
                onClick={(e) => {
                  e.stopPropagation();
                  initiateRA(item);
                }}
              >
                RA
              </div>
            </OverlayTrigger>
          )} */}
          {item?.tncDocument && (
            <OverlayTrigger
              placement="right"
              overlay={<Tooltip>Terms and Conditions</Tooltip>}
            >
              <div
                className={Styles.iconContainer}
                style={{ background: "#fd7e14" }}
                onClick={(e) => {
                  e.stopPropagation();
                  handleViewFile(item?.tncDocument);
                }}
              >
                <RemoveRedEyeIcon style={{ fontSize: "20px", color: "#fff" }} />
              </div>
            </OverlayTrigger>
          )}
          <OverlayTrigger placement="right" overlay={<Tooltip>Chats</Tooltip>}>
            <div
              className={Styles.iconContainer}
              style={{ background: "#fd7e14" }}
              onClick={(e) => {
                e.stopPropagation();
                handleChatClick(e, item);
              }}
            >
              <ChatIcon style={{ fontSize: "20px", color: "#fff" }} />
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            placement="right"
            overlay={<Tooltip>Duplicate Listing</Tooltip>}
          >
            <div
              className={Styles.iconContainer}
              style={{ background: "#fd7e14" }}
              onClick={(e) => {
                e.stopPropagation();
                handleDuplicateClick(item);
              }}
            >
              <ContentCopyIcon style={{ fontSize: "16px", color: "#fff" }} />
            </div>
          </OverlayTrigger>
          <Menu
            id="long-menu"
            MenuListProps={{
              "aria-labelledby": "long-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={(e) => handleClose(e)}
            PaperProps={{
              style: {
                maxHeight: ITEM_HEIGHT * 4.5,
                width: "30ch",
              },
            }}
          >
            {acceptedCapData?.length > 0 ? (
              acceptedCapData?.map((capName) => (
                <MenuItem
                  key={capName}
                  onClick={(e) => {
                    handleCapNameClick(e, capName);
                  }}
                >
                  {capName}
                </MenuItem>
              ))
            ) : (
              <MenuItem
                onClick={(e) => {
                  handleClose(e);
                }}
              >
                No Chats Initiated With this Listing
              </MenuItem>
            )}
          </Menu>
        </div>
      </div>
      {isModel && role === "CONSUMER" && (
        <ConsumerCapacityModal
          isOpen={isModel}
          handleSubmit={handleEditClick}
          getMatchingProfilesCon={getMatchingProfilesCon}
          duplicate={duplicate}
        />
      )}
      {isModel && role === "GENERATOR" && (
        <PreviewModel
          isOpen={isModel}
          handleSubmit={handleEditClick}
          duplicate={duplicate}
        />
      )}
      {isOpenChat && (
        <Chat
          isOpen={isOpenChat}
          closeChatModal={() => {
            setOpenChat(false);
          }}
          UserCapName={UserCapName}
        />
      )}
    </>
  );
};

export default MyListCard;
